import React from "react";

import { InvestorSectionIcon } from "./InvestorMetricIcons";

/** Icon + label row for wallet toolbar buttons and links. */
export default function WalletToolbarLabel({ icon, children }) {
  return (
    <span className="wallet-toolbar__label">
      {icon ? (
        <span className="wallet-toolbar__icon" aria-hidden>
          <InvestorSectionIcon name={icon} />
        </span>
      ) : null}
      <span>{children}</span>
    </span>
  );
}
